import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class SecureNuanceLiveAgentMessageRecord
 * @augments BaseMessageRecord
 */
class SecureNuanceLiveAgentMessageRecord extends BaseMessageRecord({
  type: "nuance_secure_live_agent",
  fallbackResponseId: null,
  businessUnitId: null,
  agentGroupId: null,
  secureEnabled: false,
  securePrompt: ""
}) {
  static getInvalidFields = () => Immutable.List()
}

export default SecureNuanceLiveAgentMessageRecord;
